import { render } from "./commentWithTools.vue?vue&type=template&id=0f265606&scoped=true"
import script from "./commentWithTools.vue?vue&type=script&lang=js"
export * from "./commentWithTools.vue?vue&type=script&lang=js"

import "./commentWithTools.vue?vue&type=style&index=0&id=0f265606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f265606"]])

export default __exports__